import React, { useEffect } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Mixpanel } from "../../../components/shared/Mixpanel";
import * as SearchActions from "../../../redux/actions/search";
import * as TheWireActions from "../../../redux/actions/thewire";

import selectVideos from "../../../redux/reselect/thewire/selectVideos";

import SiteContainer from "../container";
import Page from "../../index";
import Container from "./Container";

import "video.js/dist/video-js.min.css";

function TheWire(props) {
  useEffect(() => {
    Mixpanel.track("View Privacy Policy");
  }, []);

  return (
    <Page
      title="Privacy Policy"
      description="Privacy Policy | Jukin Licensing"
      contentType="website"
    >
      <SiteContainer headerSticky={false}>
        <Container {...props} />
      </SiteContainer>
    </Page>
  );
}

const mapStateToProps = (state) => ({
  filter: state.thewire.filter,
  mode: state.thewire.mode,
  dayFilter: state.thewire.dayFilter,
  offset: state.thewire.offset,
  trending: state.thewire.trending,
  fetching: state.thewire.fetching,
  noMore: state.thewire.noMore,
  hasNewVideo: state.thewire.hasNewVideo,
  acquisitions: state.thewire.acquisitions,

  videos: selectVideos(state)
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...SearchActions, ...TheWireActions }, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(TheWire);
